module.exports = __webpack_public_path__ + "static/media/Foto-producto-zona-lactancia-V2.0b51febb.jpg";